import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Admin = ({ userRights }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    adminLinks: {
      manageAccount,
      manageQuote,
      orderManagement,
      defectManagement
    }
  } = localizedStrings;
  return (
    userRights.isAdminBandVisible && (
      <>
        {userRights.isUserPageVisible && (
          <li>
            <div>
              <Link variant="link" to="/users">
                {manageAccount}
              </Link>
            </div>
          </li>
        )}
        {userRights.isQuoteApprovalDashboardVisible && (
          <li>
            <div>
              <Link variant="link" to="/quote-approval">
                {manageQuote}
              </Link>
            </div>
          </li>
        )}
        {userRights.isSOVDashboardVisible && (
          <li>
            <div>
              <Link variant="link" to="/orders">
                {orderManagement}
              </Link>
            </div>
          </li>
        )}
        {userRights.isDefectManagementVisible && (
          <li>
            <div>
              <Link variant="link" to="/defects">
                {defectManagement}
              </Link>
            </div>
          </li>
        )}
      </>
    )
  );
};

Admin.propTypes = {
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isQuoteApprovalDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool,
    isDefectManagementVisible: PropTypes.bool
  }).isRequired
};

export default Admin;
